<template>
	<div>
		
		<stato-fase
			:fase-with-stati="faseWithStati"
			:pratica="pratica"
			:pratica-diff="praticaDiff"
			@update-id-stato="pratica.id_stato_fase_6 = $event"
			:disabled="isLoading"
			:action="action"
		></stato-fase>
		
		<!--<div-->
		<!--	:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"-->
		<!--	class="my-4"-->
		<!--&gt;</div>-->
		
		<!--<v-row class="mb-5 font-weight-medium">-->
		<!--	<v-col>-->
		<!--		<div v-html="faseWithStati.descrizione"></div>-->
		<!--	</v-col>-->
		<!--</v-row>-->
		
		<v-row>
			<v-col>
				<template v-if="(action == 'store' && isAccountManager) || (action == 'edit' && ((isCoordinatore && pratica.id_stato_fase_6 != 13) || isAccountManager))">
					<v-badge
						:value="haveFilesBeenModified.screenshot_registrazione"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-file-input
							v-model="files.screenshot_registrazione"
							label="Screenshot schermata registrazione"
							hide-details
							outlined
							dense
							clearable
							accept="image/png, image/jpeg, image/jpg"
							truncate-length="120"
							@change="setChanged(files.screenshot_registrazione)"
							@click:clear="pratica.path_screenshot_registrazione = null"
							:loading="isLoadingScreenshotRegistrazione"
							:disabled="isLoading"
						>
							<template
								v-slot:append
								v-if="pratica.path_screenshot_registrazione !== null && !isLoadingScreenshotRegistrazione"
							>
								<template>
									<v-progress-circular
										v-if="downloadingScreenshotRegistrazione"
										size="24"
										width="3"
										color="primary"
										indeterminate
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="download(pratica.path_screenshot_registrazione, 'screenshot_registrazione')"
									>
										mdi-tray-arrow-down
									</v-icon>
								</template>
							</template>
						</v-file-input>
					</v-badge>
				</template>
				
				<template v-else-if="action == 'show' || (isCoordinatore && pratica.id_stato_fase_6 == 13)">
					<v-text-field
						:value="getFileNameFromPath(pratica.path_screenshot_registrazione)"
						label="Screenshot schermata registrazione"
						hide-details
						outlined
						dense
						readonly
					>
						<template
							v-slot:append
							v-if="pratica.path_screenshot_registrazione !== null"
						>
							<template>
								<v-progress-circular
									v-if="downloadingScreenshotRegistrazione"
									size="24"
									width="3"
									color="primary"
									indeterminate
								></v-progress-circular>
								<v-icon
									v-else
									class="ml-3"
									@click="download(pratica.path_screenshot_registrazione, 'screenshot_registrazione')"
								>
									mdi-tray-arrow-down
								</v-icon>
							</template>
						</template>
					</v-text-field>
				</template>
				
			</v-col>
		</v-row>
		
		<template v-if="!isCliente || (isCliente && pratica.id_stato_fase_6 != 12)">
			<v-row v-if="pratica.data_ora_screenshot_registrazione">
				<v-col>
					Caricato il {{ getDateFromDateTime(pratica.data_ora_screenshot_registrazione) }}
				</v-col>
			</v-row>
			
			<v-row>
				<v-col cols="6">
					<v-progress-linear
						v-if="isLoadingBase64ScreenshotRegistrazione"
						indeterminate
					></v-progress-linear>
					<v-img
						v-else
						:src="base64ScreenshotRegistrazione"
						contain
					></v-img>
				</v-col>
			</v-row>
		</template>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/event-bus";
export default {
	props: ['value', 'action', 'faseWithStati', 'praticaDiff', 'haveFilesBeenModified'],
	data() {
		return {
			pratica: {
				id: null,
				id_stato_fase_6: null,
				ci_sono_aggiornamenti_fase_6: false,
				path_screenshot_registrazione: null,
				data_ora_screenshot_registrazione: null
			},
			isLoadingScreenshotRegistrazione: false,
			files: {
				screenshot_registrazione: null
			},
			downloadingScreenshotRegistrazione: false,
			isLoadingBase64ScreenshotRegistrazione: false,
			base64ScreenshotRegistrazione: null
		}
	},
	
	created() {
		this.isSettingPratica = true;
		// this.pratica = Object.assign({}, this.value);
		this.pratica = this.value;
		this.isSettingPratica = false;
		
		// aggiorno sul db
		if (this.pratica.ci_sono_aggiornamenti_fase_6 && this.isCliente) {
			this.pratica.ci_sono_aggiornamenti_fase_6 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_fase_6',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_fase_6');
		}
		
		if (this.pratica.path_screenshot_registrazione !== null) {
			this.getBase64ScreenshotRegistrazione();
			
			if (this.action != 'show' && !this.isCliente) this.getScreenshotRegistrazione();
		}
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			isCoordinatore: 'auth/isCoordinatore'
		}),
		isLoading() {
			return this.isSettingPratica
				|| this.isLoadingScreenshotRegistrazione
				|| this.isLoadingBase64ScreenshotRegistrazione;
		}
	},
	
	watch: {
		pratica: {
			handler(newPratica) {
				if (!this.isLoading) {
					this.$emit('input', newPratica)
				}
			},
			deep: true
		},
		files: {
			handler(newFiles) {
				if (!this.isLoading) {
					this.$emit('update-files', newFiles)
				}
			},
			deep: true
		},
		isLoading(newVal) {
			this.$emit('is-loading', newVal)
		},
	},
	
	methods: {
		async getScreenshotRegistrazione() {
			this.isLoadingScreenshotRegistrazione = true;
			this.files.screenshot_registrazione = await this.getFile(this.pratica.path_screenshot_registrazione);
			this.files.screenshot_registrazione.changed = false;
			this.isLoadingScreenshotRegistrazione = false;
		},
		getBase64ScreenshotRegistrazione() {
			this.isLoadingBase64ScreenshotRegistrazione = true;
			return axios.post('/api/storage/get-base-64-file', { path: this.pratica.path_screenshot_registrazione})
				.then(response => {
					this.base64ScreenshotRegistrazione = response.data;
				})
				.finally(() => {
					this.isLoadingBase64ScreenshotRegistrazione = false;
				})
		},
		download(path, key) {
			const fileName = this.getFileNameFromPath(path);
			if (key == 'screenshot_registrazione') this.downloadingScreenshotRegistrazione = true;
			axios.post('/api/storage/download',
				{
					path: path
				},
				{
					responseType: 'blob'
				})
				.then(response => {
					saveAs(response.data, fileName);
				})
				.finally(() => {
					if (key == 'screenshot_registrazione') this.downloadingScreenshotRegistrazione = false;
				})
		},
		setChanged(file) {
			if (file !== null && !this.isLoading) file.changed = true;
			// console.log(this.files)
		},
	}
	
}
</script>

<style scoped>

</style>